<template>
  <div>
    <transition name="slide-fade">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        v-model="modal"
        v-if="!modalMini"
        hide-footer
        id="add-contact"
        modal-class="overflow-hidden"
        ignore-enforce-focus-selector="input"
        scrollable
        centered
      >
        <template #modal-header="{ close }">
          <h5 class="modal-title">Call Center CRM</h5>
          <a
            href="#"
            class="minus"
            data-dismiss="modal"
            @click="modalMini = true"
          >
            <i class="bx bx-minus"></i>
          </a>
          <button :disabled="loadingCallio" type="button" class="close" @click="closeDialog(close)">
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <VueLoadingOverlay
          :active.sync="loadingCallio"
          :is-full-page="false"
        ></VueLoadingOverlay>
        <div class="row">
          <div class="col-lg-7">
            <div class="call-info">
            <div class="select-ext">
              <h5>Số</h5>
                <Select2
                v-model="phoneSelect"
                :options="arrOptionPhone"
                @change="setOperator().then(()=>registerUserAgent())"
                class="option-ext"
                />
            </div>
              <div class="call-detail">
                <div class="callio-text">
                  <p v-if="currentUserCall.phone">
                    <strong>{{ currentUserCall.phone | encryptPhone }}</strong>
                    <span class="d-block">{{ currentUserCall.name }}</span>
                    <span style="line-height: 10px;" class="d-block"
                      >{{ currentUserCall.district }} -
                      {{ currentUserCall.city }}</span
                    >
                  </p>
                  <br />
                  <span
                    class="badge-custom badge badge-pill badge-primary"
                    v-show="callStatus.statusText === 'Calling'"
                    >Đang gọi...</span
                  >
                  <span
                    class="badge-custom badge badge-pill badge-primary"
                    v-show="callStatus.statusText === 'IncomingCalling'"
                    >Có cuộc gọi đến...</span
                  >
                  <span
                    class="badge-custom badge badge-pill badge-success"
                    v-show="callStatus.statusText === 'Call'"
                    >{{ callStatus.timing.minute || "00" }} :
                    {{ callStatus.timing.second || "00" }}</span
                  >
                  <span
                    class="badge-custom badge badge-pill badge-secondary"
                    v-show="callStatus.statusText === 'Called'"
                    >{{ callStatus.timing.minute || "00" }} :
                    {{ callStatus.timing.second || "00" }}</span
                  >
                </div>
                <div class="callio-icon">
                  <span
                    v-show="callStatus.onCall"
                    @click="onMute()"
                    :class="callStatus.isMute ? 'mute' : 'toggle-speaker'"
                  ></span>
                  <img
                    v-show="
                      !callStatus.onCall &&
                        !callStatus.incoming &&
                        callStatus.canCall &&
                        !callStatus.waitingCall &&
                        currentUserCall.phone
                    "
                    class="cursor"
                    @click="onStartCall(currentUserCall)"
                    src="@/assets/img/call-icon.svg"
                    alt=""
                  />
                  <img
                    v-show="callStatus.waitingCall"
                    src="@/assets/img/call-icon.svg"
                  />
                  <img
                    v-show="callStatus.onCall || callStatus.incoming"
                    @click="onEndCall"
                    class="cursor"
                    src="@/assets/img/deny-call.svg"
                    alt=""
                  />
                  <img
                    class="cursor"
                    v-show="callStatus.incoming"
                    @click="onStartAnswer()"
                    src="@/assets/img/call-icon.svg"
                    alt=""
                  />
                </div>
              </div>
              <div class="contact-result py-3">
                <ul class="nav nav-tabs">
                  <li class="nav-item" @click="onClickResultCall">
                    <a :class="`nav-link ${tab ? 'active' : ''}`"
                      >Kết quả cuộc gọi</a
                    >
                  </li>
                  <li class="nav-item" @click="tab = false">
                    <a :class="`nav-link ${!tab ? 'active' : ''}`"
                      >Lịch sử cuộc gọi</a
                    >
                  </li>
                </ul>
                <div>
                  <div v-if="tab">
                    <ValidationObserver ref="resultCall">
                      <form @submit.prevent>
                        <ValidationProvider
                          name="Kết quả cuộc gọi"
                          rules="required"
                          v-slot="{ errors, valid }"
                        >
                          <b-form-group>
                            <b-form-radio-group
                              :state="errors[0] ? false : valid ? true : null"
                              v-model="formResult.crmResult"
                            >
                              <ul class="list-phone">
                                <li
                                  v-for="resultStatusCall in resultStatusCalls"
                                  :key="resultStatusCall.code"
                                >
                                  <b-form-radio
                                    :value="resultStatusCall.code"
                                    >{{ resultStatusCall.value }}</b-form-radio
                                  >
                                </li>
                                <li>
                                  <p class="text-danger">{{ errors[0] }}</p>
                                </li>
                              </ul>
                            </b-form-radio-group>
                          </b-form-group>
                        </ValidationProvider>
                        <div class="contact-note pt-3">
                          <h3>Ghi chú</h3>
                          <div class="form-group">
                            <textarea
                              v-model="formResult.crmNote"
                              class="form-control"
                              rows="5"
                            ></textarea>
                          </div>
                        </div>
                        <button
                          type="submit"
                          class="btn btn-primary float-right"
                          @click="submitResultCall()"
                        >
                          Cập nhật
                        </button>
                      </form>
                    </ValidationObserver>
                  </div>
                  <div v-else>
                    <b-table
                      striped
                      hover
                      :items="historyCall"
                      :fields="historyCallFields"
                      thead-class="thead-light"
                      sticky-header="500px"
                      responsive
                      show-empty
                      empty-text="Không có dữ liệu!"
                    >
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(toNumber)="data">
                        <strong>{{ data.item.toNumber | encryptPhone }}</strong
                        ><br />{{ data.item.contactName }}
                      </template>
                      <template #cell(username)="data">
                        <strong>{{ data.item.username }}</strong
                        ><br />{{ data.item.userEmail }}
                      </template>
                      <template #cell(initCallIoTime)="data">
                        {{ data.item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                      </template>
                      <template #cell(createCallIoTime)="data">
                        {{ data.item.createCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}<br />
                        {{ data.item.endCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                      </template>
                      <template #cell(timing)="data">
                        {{ getTiming(data.item.endCallIoTime, data.item.createCallIoTime) }}
                      </template>
                      <template #cell(direction)="data">
                        {{ data.item.direction | formatDirection }}
                      </template>
                      <template #cell(crmResult)="data">
                        <a
                          v-if="!data.item.crmResult"
                          href="#"
                          @click="setResultCall(data.item)"
                          >Chọn kết quả cuộc gọi</a
                        >
                        <span v-else
                          >{{
                            data.item.crmResult | resultCall(resultStatusCalls)
                          }}
                          <br />
                          {{ data.item.crmNote }}
                        </span>
                      </template>
                      <template #cell(action)="data">
                        <b-dropdown class="text-center" variant="outline-light">
                          <b-dropdown-item
                          @click="detail(data.item.id)"
                            class="dropdown-item"
                            ><span>&nbsp;</span>Chi tiết
                          </b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5" style="overflow: scroll;height: 700px">
            <div class="list-contact-wrapper">
              <div class="list-contact">
                <h3 class="dropdown">
                  Liên hệ chính
                </h3>
                <div v-if="mainContact" class="list-contact-detail">
                  <div class="lcd-text">
                    <p class="call-number">{{ mainContact.phone | encryptPhone}}</p>
                    <p class="call-name">
                      {{ mainContact.name }}
                    </p>
                    <p class="call-note d-inline-block"></p>
                  </div>
                  <div class="call-icon">
                    <span
                      ><img
                        @click="
                          callAndSetUser({
                            name: mainContact.name,
                            phone: mainContact.phone
                          })
                        "
                        src="@/assets/img/call-icon.svg"
                        alt="call-icon"
                    /></span>
                  </div>
                </div>
                <h3 class="dropdown">
                  Liên hệ khác
                  <a
                    href="#"
                    @click="showFormOtherContact = true"
                    class="dropdown-toggle"
                    ><i class="bx bx-plus"></i
                  ></a>
                </h3>
                <div
                  class="list-contact-detail"
                  v-show="!showFormOtherContact"
                  v-for="contact in otherContact"
                  :key="contact.contactId"
                >
                  <div class="lcd-text">
                    <p class="call-number">{{ contact.contactMobile | encryptPhone}}</p>
                    <p class="call-name">
                      {{ contact.contactName }}
                    </p>
                    <p class="call-note d-inline-block">
                      {{ contact.contactNote || "" }}
                    </p>
                  </div>
                  <div class="call-icon">
                    <span
                      ><img
                        @click="
                          callAndSetUser({
                            name: contact.contactName,
                            phone: contact.contactMobile
                          })
                        "
                        src="@/assets/img/call-icon.svg"
                        alt="call-icon"
                    /></span>
                    <div class="dropdown">
                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <i class="bx bx-dots-vertical-rounded p-0"></i>
                      </button>
                      <div
                        class="dropdown-menu"
                        style="
                            width: 60px !important;
                            padding: 0;
                            left: 0 !important;
                            top: 33px !important;
                          "
                        aria-labelledby="dropdownMenuButton"
                      >
                        <button
                          class="dropdown-item edit-show"
                          @click="
                            () => {
                              showFormOtherContact = true;
                              formOtherContact = { ...contact };
                            }
                          "
                        >
                          Sửa
                        </button>
                        <button
                          class="dropdown-item edit-del"
                          @click="contact.showDelete = true"
                        >
                          Xóa
                        </button>
                      </div>
                    </div>
                  </div>
                  <a
                    v-show="contact.showDelete"
                    href="#"
                    @click="deleteOtherContact(contact.contactId)"
                    class="lct-button"
                    >Xác nhận xóa</a
                  >
                </div>
              </div>
              <div class="add-contact-form" v-show="showFormOtherContact">
                <ValidationObserver ref="otherContact">
                  <form @submit.prevent class="p-3">
                    <h4 class="mb-3">
                      {{
                        formOtherContact.contactId
                          ? "Sửa liên hệ"
                          : "Tạo liên hệ"
                      }}
                      <span @click="resetFormOtherContact" class="icon-close"
                        ><i class="bx bx-x"></i
                      ></span>
                    </h4>
                    <ValidationProvider
                      rules="required"
                      vid="phone"
                      name="Số điện thoại"
                    >
                      <div class="form-group row mt-2" slot-scope="{ errors }">
                        <label class="col-sm-4 col-form-label"
                          >Số điện thoại</label
                        >
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formOtherContact.contactMobile"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" vid="name" name="Họ và tên">
                      <div class="form-group row mt-2" slot-scope="{ errors }">
                        <label class="col-sm-4 col-form-label">Họ và tên</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formOtherContact.contactName"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" vid="role" name="Chức vụ">
                      <div class="form-group row mt-2" slot-scope="{ errors }">
                        <label class="col-sm-4 col-form-label">Chức vụ</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formOtherContact.contactRole"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="" vid="ext" name="ext">
                      <div class="form-group row mt-2" slot-scope="{ errors }">
                        <label class="col-sm-4 col-form-label">Ghi chú</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formOtherContact.contactNote"
                          />
                          <p class="text-danger">{{ errors[0] }}</p>
                        </div>
                      </div>
                    </ValidationProvider>
                    <div class="form-group mb-0 row mt-2">
                      <div class="offset-sm-4 col-sm-8">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="submitOtherContact()"
                        >
                          {{
                            formOtherContact.contactId ? "Cập nhập" : "Thêm mới"
                          }}
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </transition>
    <div v-if="modal && modalMini">
      <div id="add-contact-minus">
        <div
          class="modal-content"
          @mouseover="grow = true"
          @mouseleave="grow = false"
        >
          <div class="modal-header">
            <h5 class="modal-title">Call Center CRM</h5>
            <a href="#" class="minus" @click="modalMini = false">
              <i class="bx bx-expand"></i>
            </a>
            <button :disabled="loadingCallio" type="button" class="close" @click="closeDialog()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <transition name="grow">
            <div v-if="grow" class="modal-body p-0">
              <VueLoadingOverlay
                :active.sync="loadingCallio"
                :is-full-page="false"
              ></VueLoadingOverlay>
              <div class="call-info">
                <div class="call-detail">
                  <div class="callio-text">
                    <p v-if="currentUserCall.phone">
                      <strong>{{ currentUserCall.phone }}</strong>
                      <span class="d-block">{{ currentUserCall.name }}</span>
                      <span style="line-height: 10px;" class="d-block"
                        >{{ currentUserCall.district }} -
                        {{ currentUserCall.city }}</span
                      >
                    </p>
                    <br />
                    <span
                      class="badge-custom badge badge-pill badge-primary"
                      v-show="callStatus.statusText === 'Calling'"
                      >Đang gọi...</span
                    >
                    <span
                      class="badge-custom badge badge-pill badge-primary"
                      v-show="callStatus.statusText === 'IncomingCalling'"
                      >Có cuộc gọi đến...</span
                    >
                    <span
                      class="badge-custom badge badge-pill badge-success"
                      v-show="callStatus.statusText === 'Call'"
                      >{{ callStatus.timing.minute || "00" }} :
                      {{ callStatus.timing.second || "00" }}</span
                    >
                    <span
                      class="badge-custom badge badge-pill badge-secondary"
                      v-show="callStatus.statusText === 'Called'"
                      >{{ callStatus.timing.minute || "00" }} :
                      {{ callStatus.timing.second || "00" }}</span
                    >
                  </div>
                  <div class="callio-icon">
                    <span
                      v-show="callStatus.onCall"
                      @click="onMute()"
                      :class="callStatus.isMute ? 'mute' : 'toggle-speaker'"
                    ></span>
                    <img
                      v-show="
                        !callStatus.onCall &&
                          !callStatus.incoming &&
                          callStatus.canCall &&
                          !callStatus.waitingCall &&
                          currentUserCall.phone
                      "
                      class="cursor"
                      @click="onStartCall(currentUserCall)"
                      src="@/assets/img/call-icon.svg"
                      alt=""
                    />
                    <img
                      v-show="callStatus.waitingCall"
                      src="@/assets/img/call-icon.svg"
                    />
                    <img
                      v-show="callStatus.onCall || callStatus.incoming"
                      @click="onEndCall"
                      class="cursor"
                      src="@/assets/img/deny-call.svg"
                      alt=""
                    />
                    <img
                      class="bx-tada"
                      v-show="callStatus.incoming"
                      @click="onStartAnswer()"
                      src="@/assets/img/call-icon.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import pad from 'lodash/pad'
import { mapGetters } from 'vuex'
import { CallIoService } from '@/services/callio.service'
import md5 from 'md5'
import JsSIP from 'jssip'

export default {
  data () {
    return {
      mainContact: {},
      email: null,
      operator: null,
      resultStatusCalls: null,
      grow: false,
      loadingIcon: false,
      loadingCallio: true,
      socketUA: '',
      session: '',
      callId: {
        backend: null
      },
      callStatus: {
        waitingCall: false,
        isMute: false,
        incoming: false,
        onCall: false,
        ringing: new Audio(require('@/assets/telephone-ring.mp3')),
        timing: {
          minute: null,
          second: null
        },
        statusText: null,
        canCall: false,
      },
      totalSeconds: 0,
      intervalTime: null,
      callIoConfig: {
        host: 'vimo.phonenet.io'
      },
      callOptions: {
        mediaConstraints: {
          audio: true,
          video: false
        },
        pcConfig: {
          iceServers: [
            { urls: ['stun:stun.l.google.com:19302'] },
            {
              urls: 'turn:numb.viagenie.ca',
              username: 'webrtc@live.com',
              credential: 'muazkh'
            }
          ]
        },
        extraHeaders:[]
      },
      formResult: {
        crmNote: null,
        crmResult: null,
        id: null
      },
      tab: false,
      showFormOtherContact: false,
      historyCall: [],
      otherContact: [],
      historyCallFields: [
        { key: 'index', label: 'STT' },
        { key: 'toNumber', label: 'Liên hệ' },
        { key: 'username', label: 'Nhân sự' },
        { key: 'initCallIoTime', label: 'TG khởi tạo' },
        { key: 'createCallIoTime', label: 'TG thực hiện' },
        { key: 'timing', label: 'TG gọi' },
        { key: 'direction', label: 'Chiều gọi' },
        { key: 'crmResult', label: 'Kết quả' },
        { key: 'action', label: 'Thao tác', fixIndex: 999 }
      ],
      formOtherContact: {
        contactMobile: null,
        contactName: null,
        contactNote: null,
        contactRole: null,
        customerId: null,
        contactId: null
      },
      firstLoad: false,
      phoneSelect:"",
      extOption:[],
      token: 'b84b3520bde2bb03dfc3e1e2df26835957140ce5c6ae213e0fd5501f227d6ef505ebe0bd7c41eb357803b9d309df96c79130d855ba2bfe1fd5da264eabc194fb',
      phoneOption:[],
      userExt:[],
      arrOptionPhone:[]
    }
  },
  computed: {
    modal: {
      get () {
        return this.$store.state.callio.modal
      },
      set (val) {
        this.$store.commit('callio/SET_MODAL', val)
      }
    },
    modalMini: {
      get () {
        return this.$store.state.callio.modalMini
      },
      set (val) {
        this.$store.commit('callio/SET_MODAL_MINI', val)
      }
    },
    ...mapGetters({
      dataPermission: 'role/dataPermission',
      currentUserCall: 'callio/currentUserCall',
      tmpCurrentCallUser: 'callio/tmpCurrentCallUser'
    })
  },

  async created () {
    this.getPhoneNumber()
  },

  methods: {
    onClickResultCall() {
      this.tab = true
      this.fetchResultStatusCall()
    },
    async init () {
      if (this.firstLoad === false) {
        this.firstLoad = true
        try {
          this.setOperator().then(() => {
            this.registerUserAgent()
          })
        } catch (error) {
          this.firstLoad = false
        }
      }
    },
    closeDialog (evt) {
      this.onEndCall()
      if (evt) evt()
      this.$store.commit('callio/SET_MODAL', false)
    },
    getTiming (endCallIoTime, createCallIoTime) {
      if (!endCallIoTime) return ''
      const end = moment(endCallIoTime)
      const start = moment(createCallIoTime)
      const duration = moment.duration(end.diff(start))
      return `${pad(duration.hours(), 2, '0')}:${pad(
        duration.minutes(),
        2,
        '0'
      )}:${pad(duration.seconds(), 2, '0')}`
    },
    async callAndSetUser (data) {
      await this.setCurrentUserCall(data, false)
      this.onStartCall(this.currentUserCall)
    },
    async setCurrentUserCall (data, isWatch) {
      try {
        if (!this.callStatus.onCall && !this.callStatus.incoming) {
          if (data.customerId) {
            data.name = data.customerName
            data.phone = data.mobile
            this.mainContact = {
              name: data.customerName,
              phone: data.mobile
            }
            this.email = data.email
          }
          if (isWatch) {
            this.$store.commit('callio/SET_CURRENT_USER_CALL', data)
          } else {
            const payload = {
              ...this.currentUserCall,
              ...data
            }
            this.$store.commit('callio/SET_CURRENT_USER_CALL', payload)
          }
          if (data.customerId) {
            this.loadingCallio = true
            await this.fetchContacts(
              (this.formOtherContact.customerId = data.customerId)
            )
            await this.fetchHistory(data)
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingCallio = false
      }
    },
    registerUserAgent () {
      if (navigator.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia(this.callOptions.mediaConstraints)
          .then(() => {
            this.socketUA = new JsSIP.UA({
              sockets: [
                new JsSIP.WebSocketInterface(
                  `wss://${this.callIoConfig.host}:7443`
                )
              ],
              uri: `sip:${this.callIoConfig.ext}@${this.callIoConfig.host}`,
              realm: this.callIoConfig.host,
              ha1: md5(
                `${this.callIoConfig.ext}:${this.callIoConfig.host}:${this.callIoConfig.password}`
              ),
              contact_uri: this.callIoConfig.contact_uri,
              session_timers: false
            })
            this.socketUA.start()
            this.onRegistered()
            this.onInitCall()
          })
          .catch(e => {
            console.log(e);
            this.callStatus.canCall = false
          })
      }
    },
    onRegistered () {
      this.socketUA.on('registered', () => {
        this.callStatus.canCall = true
      })
    },
    onInitCall () {
      this.socketUA.on('newRTCSession', async data => {
        if (!this.callStatus.onCall && !this.callStatus.incoming) {
          this.session = data.session
        }

        this.session.on('progress', e => {
          console.log('progress: ',e)
          if (e.originator === 'local') {
            // incoming session
            this.$store.commit('callio/SET_CURRENT_USER_CALL', {
              phone: `0${data.session.remote_identity.display_name}`,
              name: 'Khách hàng'
            })
            this.callStatus.incoming = true
            this.callStatus.statusText = 'IncomingCalling'
            this.startRinging()
            if (!this.modal && !this.modalMini) {
              this.modal = true
              this.modalMini = true
              this.grow = true
            }
          } else if (e.originator === 'remote') {
            // outgoing session
            this.callStatus.waitingCall = false
            this.callStatus.onCall = true
            this.callStatus.statusText = 'Calling'
            this.loadingCallio = false
          }
        })

        this.session.on('icecandidate', event => {
          console.log('icecandidate: ',event)
          if (
            event.candidate.relatedAddress !== null &&
            event.candidate.relatedPort !== null
          ) {
            event.ready()
          }
        })

        this.session.on('accepted', async e => {
          console.log('accepted: ',e)
          this.callStatus.statusText = 'Call'
          this.startCountTime()
          if (e.originator === 'local') {
            // incoming session
            this.callStatus.onCall = true
            this.callStatus.incoming = false
            this.stopRinging()
          } else if (e.originator === 'remote') {
            // outgoing session
          }
          const response = await CallIoService.createCall({ callIoHistoryId: this.callId.backend })
          if (!response.success) this.session.terminate()
        })

        this.session.on('ended', async e => {
          console.log('ended: ',e)
          this.callStatus.onCall = false
          this.callStatus.incoming = false
          this.callStatus.statusText = 'Called'
          this.callStatus.isMute = false
          this.stopCountTime()
          setTimeout(() => {
            this.callStatus.statusText = null
          }, 1500)
          await CallIoService.endCall({ callIoHistoryId: this.callId.backend, toNumber: this.currentUserCall.phone })
          this.formResult.id = this.callId.backend
          this.tab = true
          this.fetchHistory()
        })

        this.session.on('failed', async e => {
          console.log('failed: ',e)
          if (e.cause === 'Canceled' || e.cause === 'Rejected') {
            this.loadingCallio = false
            this.stopRinging()
          }
          if (e.cause === 'Canceled') {
            this.formResult.id = this.callId.backend
            this.tab = true
            this.fetchHistory()
          }
          if (e.cause === 'Not Found') {
            this.loadingCallio = false
            this.showFailMx('Số điện thoại không hợp lệ!');
          }
          if (e.cause === "Unavailable") {
            this.loadingCallio = false
            this.stopRinging()
            this.showFailMx('Vui lòng đổi số hoặc đợi trong ít phút!');
          }
          this.callStatus.statusText = null
          this.callStatus.onCall = false
          this.callStatus.incoming = false
          this.callStatus.isMute = false
        })
      })
    },
    async setOperator() {
  const crmUserId = JSON.parse(localStorage.getItem('userData')).userId
  const response = await CallIoService.getUserCallIo({ crmUserId })
  this.operator = response.data
  this.getUserOfCallIo()
  localStorage.setItem('callioConfig', JSON.stringify(this.operator))
  const random = Math.random().toString(36).substring(2, 15)
    this.callIoConfig = {
      ...{
      ext: this.operator.ext,
      password: this.operator.extPassword,
      phone: this.operator.phone,
      contact_uri: `sip:${this.operator.ext}@${random}.invalid;transport=ws`},
      host: 'vimo.phonenet.io',
    }
},


    async onStartCall (currentUserCall) {
      if (!this.callStatus.canCall) {
        this.showFailMx('Thiết bị của bạn hiện đang mất kết nối tới hệ thống điện thoại, vui lòng kiểm tra lại mic, tình trạng mang và thử lại!');
        return
      }
      if (this.loadingIcon) return
      this.loadingIcon = true
      this.loadingCallio = true
      const params = {
        contactName: currentUserCall.name ?? currentUserCall.phone,
        customerId: currentUserCall.customerId,
        toNumber: currentUserCall.phone,
        direction: 'outbound',
        merchantType: currentUserCall.merchantType
      }
      if (currentUserCall.ticketId) {
        params.ticketId = currentUserCall.ticketId;
      }

      try {
        const response = await CallIoService.initCall(params);

        if(response.success){
          if (this.phoneSelect) {
          this.callOptions.extraHeaders = [`X-CallerNumber:${this.phoneSelect}`]
        }
        this.callId.backend = response.data.id
        this.callStatus.waitingCall = true
        console.log(currentUserCall.phone);
        console.log("checkCalloptions",this.callOptions);
          this.session = this.socketUA.call(
            currentUserCall.phone,
            this.callOptions
          )
          this.session.connection.onaddstream = function (e) {
            const remoteAudio = document.createElement('audio')
            remoteAudio.srcObject = e.stream
            remoteAudio.play()
          }
          this.loadingIcon = false
        }else{
          this.loadingCallio = false
          this.showFailMx(response.message);
        }
      } catch (error) {
        this.showFailMx(error.message ?? error);
      } finally {
        this.loadingIcon = false
      }
    },

    async onStartAnswer () {
      if (!this.callStatus.canCall) {
        this.showFailMx('Thiết bị của bạn hiện đang mất kết nối tới hệ thống điện thoại, vui lòng kiểm tra lại mic, tình trạng mang và thử lại!');
        return
      }
      if (this.loadingIcon) return
      this.loadingIcon = true
      await CallIoService.initCall({
        contactName: null,
        customerId: null,
        toNumber: this.currentUserCall.phone,
        direction: 'inbound',
        merchantType: this.currentUserCall.merchantType
      })
        .then(response => {
          if (response.success) {
            this.callId.backend = response.data.id
            this.session.answer(this.callOptions)
            this.session.connection.onaddstream = function (e) {
              const remoteAudio = document.createElement('audio')
              remoteAudio.srcObject = e.stream
              remoteAudio.play()
            }
          }
        })
        .finally(e => {
          this.loadingIcon = false
        })
    },

    async fetchHistory (data = null) {
      if (!this.dataPermission.includes('CNPS_INTEG_CALLIO_VIEW')) return
      try {
        this.loadingCallio = true
        const params = {
          page: 1,
          size: 20,
          customerId: data ? data.customerId : this.currentUserCall.customerId
        }
        if (data.ticketId || this.currentUserCall.ticketId) {
          params.ticketId = data.ticketId || this.currentUserCall.ticketId;
        }
        const response = await CallIoService.getHistoryCallIo(params)
        this.historyCall = response.data.list
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingCallio = false
      }
    },

    async fetchResultStatusCall () {
      const response = await CallIoService.getResultStatusCall({ ticketId: this.currentUserCall.ticketId ?? null, typeTicket: this.currentUserCall.typeTicket ?? null })
      this.resultStatusCalls = response.data
    },

    async fetchContacts (customerId) {
      await CallIoService.getAllOtherContact({ customerId }).then(response => {
        const showDelete = false
        this.otherContact = response.data.map(data => {
          return {
            ...data,
            showDelete
          }
        })
      })
    },

    resetFormResult () {
      this.formResult.id = null
      this.formResult.crmResult = null
      this.formResult.crmNote = null
      this.$nextTick(() => {
        this.$refs.resultCall.reset()
      })
    },
    resetFormOtherContact () {
      this.formOtherContact.contactId = null
      this.formOtherContact.contactMobile = null
      this.formOtherContact.contactName = null
      this.formOtherContact.contactRole = null
      this.formOtherContact.contactNote = null
      this.$nextTick(() => {
        this.$refs.otherContact.reset()
      })
      this.showFormOtherContact = false
    },

    setResultCall (data) {
      this.formResult.id = data.id
      this.tab = true
    },

    submitResultCall () {
      if (!this.formResult.id) {
        this.showFailMx('Bạn chưa chọn cuộc gọi để cập nhật kết quả!');
        return
      }
      this.formResult.ticketId = this.currentUserCall.ticketId
      const observer = this.$refs.resultCall
      observer.validate().then(async success => {
        if (success) {
          try {
            this.loadingCallio = true
            await CallIoService.createResultCall(this.formResult).then(
              response => {
                if (response.success) {
                  this.showSuccessMx('Lưu kết quả cuộc gọi thành công!');
                  this.tab = false
                  this.resetFormResult()
                  this.fetchHistory()
                  return
                }
                this.showFailMx(response.message);
              }
            )
          } catch (error) {
            console.log(error)
          } finally {
            this.loadingCallio = false
          }
        }
      })
    },

    submitOtherContact () {
      const observer = this.$refs.otherContact
      observer.validate().then(async success => {
        if (success) {
          try {
            this.loadingCallio = true
            if (!this.formOtherContact.contactId) {
              await CallIoService.createOtherContact(
                this.formOtherContact
              ).then(response => {
                if (response.success) {
                  this.showSuccessMx('Thêm liên hệ thành công!');
                  this.resetFormOtherContact()
                  this.fetchContacts(this.formOtherContact.customerId)
                  return
                }
                this.showFailMx(response.message);
              })
              return
            }
            await CallIoService.updateOtherContact(this.formOtherContact).then(
              response => {
                if (response.success) {
                  this.showSuccessMx('Cập nhập liên hệ thành công!');
                  this.resetFormOtherContact()
                  this.fetchContacts(this.formOtherContact.customerId)
                  return
                }
                this.showFailMx(response.message);
              }
            )
          } catch (error) {
            console.log(error)
          } finally {
            this.loadingCallio = false
          }
        }
      })
    },
    async deleteOtherContact (contactId) {
      try {
        this.loadingCallio = true
        await CallIoService.deleteOtherContact({ contactId }).then(response => {
          if (response.success) {
            this.showFailMx('Xóa liên hệ thành công!');
            this.fetchContacts(this.formOtherContact.customerId)
            return
          }
          this.showFailMx(response.message);
        })
      } catch (error) {
      } finally {
        this.loadingCallio = false
      }
    },
    onEndCall () {
      try {
        if (this.session.terminate) this.session.terminate()
      } catch (error) {

      }
    },

    onMute () {
      if (!this.callStatus.isMute) {
        this.session.mute()
      } else {
        this.session.unmute()
      }
      this.callStatus.isMute = !this.callStatus.isMute
    },

    pad (val = '') {
      const valString = val + ''
      if ((valString?.length || 0) < 2) {
        return '0' + valString
      } else {
        return valString
      }
    },

    countTime () {
      this.totalSeconds++
      this.callStatus.timing.second = this.pad(this.totalSeconds % 60)
      this.callStatus.timing.minute = this.pad(
        parseInt(this.totalSeconds / 60)
      )
    },

    stopCountTime () {
      clearInterval(this.intervalTime)
      this.totalSeconds = 0
    },

    startCountTime () {
      this.callStatus.timing.second = this.callStatus.timing.minute = null
      this.intervalTime = setInterval(this.countTime, 1000)
    },

    startRinging () {
      this.callStatus.ringing.volume = 0.1
      try {
        this.callStatus.ringing.play()
      } catch (e) {
        console.log('không thể đổ chuông !')
      }
    },

    stopRinging () {
      this.callStatus.ringing.pause()
      this.callStatus.ringing.currentTime = 0
    },
    detail (id) {
    const routeData = this.$router.resolve({ path: `/call-io/${id}` })
    window.open(routeData.href, '_blank')
    console.log(routeData);
    },
    async getPhoneNumber() {
      const page = 1
      const pageSize = 100
      const response = await fetch(`https://clientapi.phonenet.io/number?page=${page}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          'token': this.token,
          'Content-Type': 'application/json'
        }
      });
      const phoneData = await response.json()
      const phoneOutbound = phoneData.docs.filter(e => e.outbound === true)
      this.phoneOption = phoneOutbound

    },
    async getUserOfCallIo() {
      const page = 1
      const pageSize = 200
      const response = await fetch(`https://clientapi.phonenet.io/user?page=${page}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          'token': this.token,
          'Content-Type': 'application/json'
        }
      });
      const userCallIoData = await response.json()
      const userExt = userCallIoData.docs.filter(e => e.ext === this.operator.ext)
      this.userExt = userExt[0].group._id
      this.getPhoneOption()
    },
    getPhoneOption(){
      const phoneTypeGroup = this.phoneOption.filter(e => (e.outboundFromType && e.outboundFromType  === 'group'))
      const phoneTypeAll = this.phoneOption.filter(e => (e.outboundFromType && e.outboundFromType  === 'all'))
      const chosephoneTypeGroup = phoneTypeGroup.filter(e => (e.outboundFromGroups && e.outboundFromGroups.includes(this.userExt)))
      const phoneTypeCustom = this.phoneOption.filter(e => (e.outboundFromType && e.outboundFromType  === 'custom'))
      const chosephoneTypeCustom = phoneTypeCustom.filter(e => (e.outboundFromPattern === this.userExt))

      let arrPhone = []
      if (phoneTypeAll.length > 0) {
        arrPhone = [...arrPhone, ...phoneTypeAll];
      }

      if (chosephoneTypeGroup.length > 0) {
        arrPhone = [...arrPhone, ...chosephoneTypeGroup];
      }

      if (chosephoneTypeCustom.length > 0) {
        arrPhone = [...arrPhone, ...chosephoneTypeCustom];
      }
      const arrOptionPhone = arrPhone.map(e => ({
        id: e.number,
        text: e.number
      }))
      this.arrOptionPhone =arrOptionPhone
    }
  },
  watch: {
    tmpCurrentCallUser: function (data) {
      this.init().then(s => {
        this.setCurrentUserCall(data, true)
      })
    }
  },
}
</script>

<style scoped>
.toast-box {
  z-index: 999999999;
}
.toast-box .modal-body {
  padding: 0;
}
.toast-box .modal-body .row {
  margin: 0;
}

.nav-link {
  color: #333 !important;
  padding: 10px 20px !important;
}

.nav-tabs li {
  cursor: pointer;
}

.dropdown-item {
  border-radius: 0 !important;
}
.badge-custom {
  font-size: 14px;
  padding: 5px 10px;
}
.grow-enter-active {
  transition: all 1s;
}
.grow-enter,
.grow-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.select-ext{
  display: flex;
  justify-content: space-around;
  width: 70%;
  margin-bottom: 20px;
}
.option-ext{
  width: 180px!important;
}
</style>
